import { render, staticRenderFns } from "./BadgeStep.vue?vue&type=template&id=4a8fbdfe&"
import script from "./BadgeStep.vue?vue&type=script&lang=ts&"
export * from "./BadgeStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a8fbdfe')) {
      api.createRecord('4a8fbdfe', component.options)
    } else {
      api.reload('4a8fbdfe', component.options)
    }
    module.hot.accept("./BadgeStep.vue?vue&type=template&id=4a8fbdfe&", function () {
      api.rerender('4a8fbdfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LobbySteps/BadgeStep.vue"
export default component.exports